import R from 'ramda'

const ONE_TIME_CONSENT_DISPLAY_TYPE = 'Received One-Time Consent'
const ONE_TIME_CONSENT_TRIGGER_TYPE = 'OPT_IN_ONE_TIME'

const isConsentFormTrigger = R.propEq('type', ONE_TIME_CONSENT_DISPLAY_TYPE)

const convertConsentFormTriggerToWidgetTrigger = R.applySpec({
  type: R.always(ONE_TIME_CONSENT_TRIGGER_TYPE),
  data: R.always('one_time_notif_req'),
  operator: R.always('AND'),
  primary: R.T
})

export { isConsentFormTrigger, convertConsentFormTriggerToWidgetTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/facebook/form-to-widget/received-onetime-consent.js